import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";

export default function Workflow() {
    const { dict, t } = useI18n();
    const steps = dict.process.steps;

    return (
        <section
            id="process"
            data-testid="process-section"
            className="section-pad relative scroll-mt-24"
        >
            <div className="container-page">
                <div className="mb-14 max-w-3xl">
                    <span className="eyebrow">{t("process.eyebrow")}</span>
                    <h2
                        data-testid="process-title"
                        className="mt-5 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter"
                    >
                        {t("process.title")}
                    </h2>
                </div>

                <div className="relative">
                    {/* connecting line */}
                    <div className="hidden lg:block absolute left-0 right-0 top-[64px] h-px bg-gradient-to-r from-transparent via-brand/40 to-transparent" />

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                        {steps.map((s, idx) => (
                            <motion.div
                                key={s.n}
                                data-testid={`process-step-${idx}`}
                                initial={{ opacity: 0, y: 18 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.5, delay: idx * 0.08 }}
                                className="relative"
                            >
                                <div className="relative z-10 inline-flex h-12 w-12 items-center justify-center rounded-full border border-brand/40 bg-ink-950 text-sm font-mono text-brand-glow">
                                    {s.n}
                                </div>
                                <div className="mt-6">
                                    <h3 className="text-xl md:text-2xl font-semibold tracking-tight">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 text-sm text-white/55 leading-relaxed max-w-xs">
                                        {s.desc}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
